import { Appearance } from '@atlaskit/modal-dialog';
import React, { forwardRef, useState } from 'react';
import { ConfirmationDialogContext } from '../context/confirmation-dialog-context';
import ConfirmationDialog from '../dialog/confirmation-dialog';

export interface ModalState {
  isModalOpen?: boolean;
  modalContent: React.ReactNode;
  modalTitle?: React.ReactNode;
  appearance?: Appearance;
}

function withConfirmationDialog(WrappedComponent: React.FC<any>) {
  return forwardRef<any, any>(function (props, ref) {
    const [modalState, setModalState] = useState<ModalState>({
      isModalOpen: false,
      modalContent: '',
      modalTitle: '',
      appearance: undefined,
    });

    const openModal = (params: ModalState) => {
      setModalState({ ...params, isModalOpen: true });
    };

    const closeModal = () => {
      setModalState((state) => ({ ...state, isModalOpen: false, isLoading: false }));
    };

    return (
      <ConfirmationDialogContext.Provider
        value={{
          openModal: openModal,
          closeModal: closeModal,
        }}
      >
        <WrappedComponent {...props} ref={ref} />
        <ConfirmationDialog
          modalContent={modalState.modalContent}
          isOpen={modalState.isModalOpen || false}
          modalTitle={modalState.modalTitle}
          appearance={modalState.appearance}
        />
      </ConfirmationDialogContext.Provider>
    );
  });
}

export default withConfirmationDialog;
